var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddLightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 18 18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#616161;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.4,2.6c-3.5-3.5-9.2-3.5-12.7,0c-3.5,3.5-3.5,9.2,0,12.7c3.5,3.5,9.2,3.5,12.7,0 C18.9,11.9,18.9,6.1,15.4,2.6z M3.5,14.5c-3-3-3-8,0-11c3-3,8-3,11,0s3,8,0,11S6.5,17.5,3.5,14.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.6,9c0-0.3-0.3-0.6-0.6-0.6H9.6V5c0-0.3-0.3-0.6-0.6-0.6C8.7,4.4,8.4,4.7,8.4,5v3.3H5C4.7,8.4,4.4,8.7,4.4,9 c0,0.3,0.3,0.6,0.6,0.6h3.3V13c0,0.2,0.1,0.3,0.2,0.4c0.1,0.1,0.3,0.2,0.4,0.2c0.3,0,0.6-0.3,0.6-0.6V9.6h3.3 C13.3,9.6,13.6,9.3,13.6,9L13.6,9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddLightIcon);
export default __webpack_public_path__ + "static/media/addLightIcon.d32d4590952eddf80e583db40cad15fb.svg";
export { ForwardRef as ReactComponent };